import useBadgeDetailRoute from '@/hooks/useBadgeDetailRoute';

import BadgeDetailDrawer from './BadgeDetailDrawer';

/**
 * Always-mounted gateway that connects the URL state to the drawer.
 * Badge resolution and inner navigation live inside BadgeDetailScene.
 */
const BadgeDetailDrawerConnected = () => {
    const {isOpen, closePopup} = useBadgeDetailRoute();
    return <BadgeDetailDrawer open={isOpen} onClose={closePopup} />;
};

export default BadgeDetailDrawerConnected;
